import React from "react";
import "./RelatedArticles.scss";
import RelatedArticlesCard from "../../atoms/related-articles-card/related-articles-card";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

const RelatedArticles = (props: ReferenciaContenido) => {
  const relatedArticlesData = props;

  const component = (dots) => {
    return (
      <div style={{ bottom: "-10px" }}>
        <ul>{dots}</ul>
      </div>
    );
  };

  const setting = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    appendDots: (dots) => component(dots),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
    ],
  };

  return (
    <div className="m-related-articles">
      <div className="center">
        <div className="m-related-articles__title">
          <h2>{relatedArticlesData?.tituloGeneral}</h2>
        </div>
      </div>

      <div className="center">
        <div className="m-related-articles__container hide-on-mobile">
          <RelatedArticlesCard
            name={
              relatedArticlesData?.referenciaPlantillaContenido[0]?.tituloBanner
            }
            date={
              relatedArticlesData?.referenciaPlantillaContenido[0]
                ?.tituloDescripcion
            }
            img={
              relatedArticlesData?.referenciaPlantillaContenido[0]
                ?.imagenPrincipal[0]?.file?.url
            }
            alt1={
              relatedArticlesData?.referenciaPlantillaContenido[0]
                ?.imagenPrincipal[0]?.title
            }
            face={
              relatedArticlesData?.referenciaPlantillaContenido[0]?.imagenPerfil
                ?.file?.url
            }
            alt2={
              relatedArticlesData?.referenciaPlantillaContenido[0]?.imagenPerfil
                ?.title
            }
            content={
              JSON.parse(
                relatedArticlesData?.referenciaPlantillaContenido[0]
                  ?.descripcion?.raw
              )?.content[0]?.content[0]?.value
            }
            redirect={
              relatedArticlesData?.referenciaPlantillaContenido[0]
                ?.redireccionBoton
            }
          />
          <RelatedArticlesCard
            name={
              relatedArticlesData?.referenciaPlantillaContenido[1]?.tituloBanner
            }
            date={
              relatedArticlesData?.referenciaPlantillaContenido[1]
                ?.tituloDescripcion
            }
            img={
              relatedArticlesData?.referenciaPlantillaContenido[1]
                ?.imagenPrincipal[0]?.file?.url
            }
            alt1={
              relatedArticlesData?.referenciaPlantillaContenido[1]
                ?.imagenPrincipal[0]?.title
            }
            face={
              relatedArticlesData?.referenciaPlantillaContenido[1]?.imagenPerfil
                ?.file?.url
            }
            alt2={
              relatedArticlesData?.referenciaPlantillaContenido[1]?.imagenPerfil
                ?.title
            }
            content={
              JSON.parse(
                relatedArticlesData?.referenciaPlantillaContenido[1]
                  ?.descripcion?.raw
              )?.content[0]?.content[0]?.value
            }
            redirect={
              relatedArticlesData?.referenciaPlantillaContenido[1]
                ?.redireccionBoton
            }
          />
          <RelatedArticlesCard
            name={
              relatedArticlesData?.referenciaPlantillaContenido[2]?.tituloBanner
            }
            date={
              relatedArticlesData?.referenciaPlantillaContenido[2]
                ?.tituloDescripcion
            }
            img={
              relatedArticlesData?.referenciaPlantillaContenido[2]
                ?.imagenPrincipal[0]?.file?.url
            }
            alt1={
              relatedArticlesData?.referenciaPlantillaContenido[2]
                ?.imagenPrincipal[0]?.title
            }
            face={
              relatedArticlesData?.referenciaPlantillaContenido[2]?.imagenPerfil
                ?.file?.url
            }
            alt2={
              relatedArticlesData?.referenciaPlantillaContenido[2]?.imagenPerfil
                ?.title
            }
            content={
              JSON.parse(
                relatedArticlesData?.referenciaPlantillaContenido[2]
                  ?.descripcion?.raw
              )?.content[0]?.content[0]?.value
            }
            redirect={
              relatedArticlesData?.referenciaPlantillaContenido[2]
                ?.redireccionBoton
            }
          />
        </div>
      </div>

      <div className="m-related-articles-mobile show-on-mobile">
        <Slider {...setting}>
          <div>
            <div className="m-related-articles-mobile__column">
              <RelatedArticlesCard
                name={
                  relatedArticlesData?.referenciaPlantillaContenido[0]
                    ?.tituloBanner
                }
                date={
                  relatedArticlesData?.referenciaPlantillaContenido[0]
                    ?.tituloDescripcion
                }
                img={
                  relatedArticlesData?.referenciaPlantillaContenido[0]
                    ?.imagenPrincipal[0]?.file?.url
                }
                alt1={
                  relatedArticlesData?.referenciaPlantillaContenido[0]
                    ?.imagenPrincipal[0]?.title
                }
                face={
                  relatedArticlesData?.referenciaPlantillaContenido[0]
                    ?.imagenPerfil?.file?.url
                }
                alt2={
                  relatedArticlesData?.referenciaPlantillaContenido[0]
                    ?.imagenPerfil?.title
                }
                content={
                  JSON.parse(
                    relatedArticlesData?.referenciaPlantillaContenido[0]
                      ?.descripcion?.raw
                  )?.content[0]?.content[0]?.value
                }
                redirect={
                  relatedArticlesData?.referenciaPlantillaContenido[0]
                    ?.redireccionBoton
                }
              />
            </div>
          </div>
          <div>
            <div className="m-related-articles-mobile__column">
              <RelatedArticlesCard
                name={
                  relatedArticlesData?.referenciaPlantillaContenido[1]
                    ?.tituloBanner
                }
                date={
                  relatedArticlesData?.referenciaPlantillaContenido[1]
                    ?.tituloDescripcion
                }
                img={
                  relatedArticlesData?.referenciaPlantillaContenido[1]
                    ?.imagenPrincipal[0]?.file?.url
                }
                alt1={
                  relatedArticlesData?.referenciaPlantillaContenido[1]
                    ?.imagenPrincipal[0]?.title
                }
                face={
                  relatedArticlesData?.referenciaPlantillaContenido[1]
                    ?.imagenPerfil?.file?.url
                }
                alt2={
                  relatedArticlesData?.referenciaPlantillaContenido[1]
                    ?.imagenPerfil?.title
                }
                content={
                  JSON.parse(
                    relatedArticlesData?.referenciaPlantillaContenido[1]
                      ?.descripcion?.raw
                  )?.content[0]?.content[0]?.value
                }
                redirect={
                  relatedArticlesData?.referenciaPlantillaContenido[1]
                    ?.redireccionBoton
                }
              />
            </div>
          </div>
          <div>
            <div className="m-related-articles-mobile__column">
              <RelatedArticlesCard
                name={
                  relatedArticlesData?.referenciaPlantillaContenido[2]
                    ?.tituloBanner
                }
                date={
                  relatedArticlesData?.referenciaPlantillaContenido[2]
                    ?.tituloDescripcion
                }
                img={
                  relatedArticlesData?.referenciaPlantillaContenido[2]
                    ?.imagenPrincipal[0]?.file?.url
                }
                alt1={
                  relatedArticlesData?.referenciaPlantillaContenido[2]
                    ?.imagenPrincipal[0]?.title
                }
                face={
                  relatedArticlesData?.referenciaPlantillaContenido[2]
                    ?.imagenPerfil?.file?.url
                }
                alt2={
                  relatedArticlesData?.referenciaPlantillaContenido[2]
                    ?.imagenPerfil?.title
                }
                content={
                  JSON.parse(
                    relatedArticlesData?.referenciaPlantillaContenido[2]
                      ?.descripcion?.raw
                  )?.content[0]?.content[0]?.value
                }
                redirect={
                  relatedArticlesData?.referenciaPlantillaContenido[2]
                    ?.redireccionBoton
                }
              />
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default RelatedArticles;
